/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_UltrawideInputs */

const en_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultrawide Display`)
};

const fr_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage ultra-large`)
};

const de_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultrawide-Display`)
};

const it_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display ultra-ampio`)
};

const ru_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сверхширокоформатный дисплей`)
};

const es_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalla ultra ancha`)
};

const zh_cn2_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超宽显示屏`)
};

const ja_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウルトラワイドディスプレイ`)
};

const hi_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अल्ट्रावाइड डिस्प्ले`)
};

const pt_pt2_workspace_ultrawide = /** @type {(inputs: Workspace_UltrawideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tela ultralarga`)
};

/**
* | output |
* | --- |
* | "Ultrawide Display" |
*
* @param {Workspace_UltrawideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_ultrawide = /** @type {((inputs?: Workspace_UltrawideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_UltrawideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_workspace_ultrawide(inputs)
	if (locale === "de") return de_workspace_ultrawide(inputs)
	if (locale === "it") return it_workspace_ultrawide(inputs)
	if (locale === "ru") return ru_workspace_ultrawide(inputs)
	if (locale === "es") return es_workspace_ultrawide(inputs)
	if (locale === "zh-CN") return zh_cn2_workspace_ultrawide(inputs)
	if (locale === "ja") return ja_workspace_ultrawide(inputs)
	if (locale === "hi") return hi_workspace_ultrawide(inputs)
	if (locale === "pt-PT") return pt_pt2_workspace_ultrawide(inputs)
	return en_workspace_ultrawide(inputs)
});